import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  X,
  Home,
  UserIcon,
  BookOpenIcon,
  Users,
  Settings,
  UsersIcon,
  PhoneCallIcon,
} from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { UserRoundCog, CircleEllipsis, ChevronDown, Globe } from "lucide-react";

const Asidebar = ({ adminSidebarOpen, setAdminSidebarOpen }) => {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isG2CDropdownOpen, setIsG2CDropdownOpen] = useState(false);
  const [isReportsDropdownOpen, setIsReportsDropdownOpen] = useState(false);
  const location = useLocation();
  const currentPath = location.pathname;

  useEffect(() => {
    const admin = localStorage.getItem("adminId");
    if (!admin) {
      navigate("/admin-login");
    }
  }, []);

  const linkClasses = (path) => `
        flex items-center px-6 py-2 mt-2 text-white
        ${
          currentPath === path
            ? "bg-green-400 text-gray-700 font-semibold"
            : "hover:bg-orange-400"
        }
    `;

  return (
    <div
      className={`${
        adminSidebarOpen ? "translate-x-0" : "-translate-x-full"
      } fixed inset-y-0 left-0 z-50 w-64 text-white shadow-lg transform transition-transform duration-300 ease-in-out lg:translate-x-0 lg:static lg:inset-0`}
      style={{ backgroundColor: "rgb(143 0 207)" }}
    >
      <div className="flex items-center justify-between h-16 bg-[#b0c22a] px-4">
        <span className="text-black text-2xl font-semibold">Admin Panel</span>
        <button
          className="text-white focus:outline-none lg:hidden"
          onClick={() => setAdminSidebarOpen(false)}
        >
          <X className="h-6 w-6" />
        </button>
      </div>
      <nav className="mt-3">
        <Link
          to="/admin/admin_dashboard"
          className={linkClasses("/admin/admin_dashboard")}
        >
          <Home className="h-5 w-5 mr-3" />
          Dashboard
        </Link>
        <Link
          to="/admin/users_data"
          className={linkClasses("/admin/users_data")}
        >
          <UsersIcon className="h-5 w-5 mr-3" />
          User Data
        </Link>
        <Link
          to="/admin/contact_data"
          className={linkClasses("/admin/contact_data")}
        >
          <PhoneCallIcon className="h-5 w-5 mr-3" />
          Contact Data
        </Link>

        <Link
          to="/admin/add_pdf"
          className={
            linkClasses("/admin/add_pdf text-2xl text-black")
          }
        >
          <BookOpenIcon className="h-5 w-5 mr-3" />
          Add Govt Books & GR
        </Link>

        <Link
          to="/admin/change-year"
          className={
            linkClasses("/admin/add_pdf text-2xl text-black")
          }
        >
          <BookOpenIcon className="h-5 w-5 mr-3" />
          GPF Change Year
        </Link>

        {/* Add 'Go to Website' button */}
        {/* <Link
                    to="/"
                    className={`flex items-center justify-center px-4 py-3 mt-9 text-green-700 font-semibold rounded-lg shadow-md transition-all duration-300 mx-8 ${('/') ? 'bg-green-500 text-white' : 'bg-green-200 text-green-800'
                        } hover:bg-orange-500 hover:text-white hover:shadow-lg transform hover:scale-105`}
                >
                    <Globe className="h-5 w-5 mr-2" />
                    Go to Website
                </Link> */}
      </nav>
    </div>
  );
};

export default Asidebar;
